// Telefones além do principal de um contato ("Telefone contato 1, 2, ..."),
// em additional_attributes.telefones_adicionais: [{ rotulo, numero }].
// O backend (Contacts::TelefonesAdicionais) limpa repetidos ao salvar.
export const CHAVE_TELEFONES = 'telefones_adicionais';

export const telefonesAdicionais = contato =>
  (contato?.additional_attributes?.[CHAVE_TELEFONES] || []).filter(
    item => item?.numero
  );

// Rótulo exibido: o que foi dado ou "Telefone contato N".
export const rotuloDoTelefone = (item, indice, t) =>
  item?.rotulo || t('CONTACT_PANEL.TELEFONE_CONTATO_N', { n: indice + 1 });
